import { render, staticRenderFns } from "./LayoutEhr.vue?vue&type=template&id=c40a09dc&scoped=true&lang=pug"
import script from "./LayoutEhr.vue?vue&type=script&lang=js"
export * from "./LayoutEhr.vue?vue&type=script&lang=js"
import style0 from "./LayoutEhr.vue?vue&type=style&index=0&id=c40a09dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40a09dc",
  null
  
)

export default component.exports